let numCheck = (rule, value, callback) => {
  let value1 = Number(value)
  if (isNaN(value1)) {
    callback(new Error('请输入数字'));
  } else if (value1 < 0) {
    callback(new Error('不应小于0'));
  } else if (value1 && Math.floor(value1) != value1) {
    callback(new Error('请输入整数'));
  } else if (String(value).length > 1 && String(value).indexOf('0') == 0) {
    callback(new Error('请输入数字'));
  } else {
    callback()
  }
}
export default {
  //人名
  name: [
    {max: 6, message: '不得超过6个字符', trigger: 'change'},
    {pattern: /^[A-Za-z\u4e00-\u9fa5]+$/, message: '请输入正确的名字', trigger: 'change'}
  ],
  //身份证号
  idcard: {
    pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
    message: '请输入15位或18位身份证号',
    trigger: 'change'
  },
  //申请人
  applicant:{
    pattern: /^[\u4e00-\u9fa5|·]{1,20}$/,
    message: '请输入正确的申请人',
    trigger: 'change'
  },
  //数字
  number: {
    validator: numCheck, trigger: 'change'
  },
  //范围校验方法
  rangeMin(value,max,callback){
      if (!value) {
        callback();
      } else {
        if ((max || max === 0) && Number(value) > Number(max)) {
          callback(new Error('范围错误'));
        } else {
          callback();
        }
      }
  },
  rangeMax(value,min,callback){
    if (!value) {
      callback();
    } else {
      if ((min || min === 0) && Number(value) < Number(min)) {
        callback(new Error('范围错误'));
      } else {
        callback();
      }
    }
  },

}


// WEBPACK FOOTER //
// ./src/common/js/formRules.js